import { EditOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import ADDGeofenceCardV3 from './geofenceCardV3'
import { connect } from 'react-redux'
import { getHolidays } from 'actions/profileNew'
import UserGeoCardsV3 from './userGeoCardsV3'
import HolidaysCalendar from './holidaysClanedar'
import LocationDrawer from './localComponent/locationDrawer'

const UserGeofenceTabV3 = ({ getHolidays, holidays, specificUserProfile, setPageLoader }) => {

    const [locationDrawerVisible, setLocationDrawerVisible] = useState(false);
    const [isAddMode, setIsAddMode] = useState(false);
    const hasCurrentLocation = Boolean(holidays?.currentLocation && (holidays.currentLocation.id || holidays.currentLocation.title));

    const params = {
        // edit: editable ? true : undefined,
        edit: undefined,
        geoFenceId: holidays?.currentLocation?.id,
        userId: specificUserProfile?.id,
        year: new Date().getFullYear()

    }
    useEffect(() => {
        if (specificUserProfile?.id) {
            setPageLoader?.(true);
            getHolidays(params, () => setPageLoader?.(false));
        }
    }, [specificUserProfile?.id]);

    const handleEditClick = () => {
        setIsAddMode(false);
        setLocationDrawerVisible(true);
    };

    const handleAddClick = () => {
        setIsAddMode(true);
        setLocationDrawerVisible(true);
    };
    

    return (
        <div className='p-20' style={{ height: '100%' }}>
            <div className='centered-flex-v3'>
                <div className='sumary-text-style-v3'>Geofences</div>
                {hasCurrentLocation ?
                    <div className='edit-button-v3' onClick={handleEditClick}> <EditOutlined /> EDIT</div>
                    :
                    null
                }
            </div>
            <div>
                {console.log("AllocatedGeoFences",holidays)}
                {!hasCurrentLocation ?
                    <ADDGeofenceCardV3 locationDrawerVisible={locationDrawerVisible} setLocationDrawerVisible={handleAddClick} getHolidays={getHolidays} params={params} geoFence={holidays}/> :
                    <UserGeoCardsV3 geoFence={holidays} locationDrawerVisible={locationDrawerVisible} setLocationDrawerVisible={setLocationDrawerVisible} getHolidays={getHolidays} params={params}/>

                }
                <HolidaysCalendar useId={specificUserProfile?.id}/>


            </div>
            <LocationDrawer
                setLocationDrawerVisible={setLocationDrawerVisible}
                locationDrawerVisible={locationDrawerVisible}
                geoFence={holidays}
                getHolidays={getHolidays}
                params={params}
                isAddMode={isAddMode}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    const { user } = state.session;
    const { holidays } = state.profileNew;
    return {
        user, holidays
    }
}

const mapDispatchToProps = (dispatch) => ({
    getHolidays: (params, callback) => dispatch(getHolidays(params, callback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserGeofenceTabV3);
